import { FC } from 'react';
import { Box } from 'roo-ui/components';
import LineItem from '../../../LineItem';
import {
  PaymentMethodBreakdownFieldsFragment as PaymentMethodBreakdown,
  QantasGroupCreditVoucherPaymentMethodFieldsFragment as QantasGroupCreditVoucherPaymentMethod,
} from 'lib/graphql';

const QantasTravelPassLineItem: FC<PaymentMethodBreakdown> = ({ total, paymentMethods }) => (
  <LineItem title="Qantas TravelPass" totals={[total]}>
    {(paymentMethods as QantasGroupCreditVoucherPaymentMethod[]).map((qantasTravelPass, index) => (
      <Box key={index}>
        Refund will be made to <strong>Qantas TravelPass {qantasTravelPass.cardNumber}</strong>
      </Box>
    ))}
  </LineItem>
);

export default QantasTravelPassLineItem;
